import React, { useEffect, useState } from "react";
import FiltersPagination from "../../../components/elements/FiltersPagination";
import DataTableElement from "../../../components/elements/DataTableElement";
import { Columns } from "./Columns";
import { reportResource, servicesRequestResource } from "../../../helpers/configRoutes/backend_helper";

const ServiceRequest = () => {
    const [filters, setFilters] = useState({ endDate: '', startDate: '', search: '', from: 0, to: 0, page: 1 });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const cols = Columns();
    const [items, setItems] = useState([]);
    const [tableLoad, setTableLoad] = useState({ show: false });
    const [serviceRequestItem, setServiceRequestItem] = useState([]);


    useEffect(() => {
        const ServiceRequest = async () => {
            try {
                const response = await reportResource("get", { param: { filters } });
                setServiceRequestItem(response.reports);
            } catch (error) {
                console.error("Error fetching service order:", error);
            }
        };

        ServiceRequest();
    }, []);

    return (
        <>
            <div className="min-h-screen bg-cs-surface">
                <div className="px-4 md:px-6 py-6 max-w-auto mx-auto">
                    {/* Header */}
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                        <div>
                            <h1 className="text-2xl font-semibold text-cs-dark">
                                Service request
                            </h1>
                            <p className="text-sm text-cs-muted mt-1">
                                Review and manage incoming service requests with filters and statuses.
                            </p>
                        </div>
                    </div>

                    {/* Tabla + filtros */}
                    <div
                        className="
          bg-cs-bg border border-cs-border rounded-2xl
          shadow-sm px-2 py-2
        "
                    >
                        <FiltersPagination
                            showFilters={true}
                            filters={filters}
                            setFilters={setFilters}
                            meta={meta}
                            statusModel="Settlement"
                        >
                            <DataTableElement
                                columns={cols}
                                items={serviceRequestItem}
                                tableLoad={tableLoad}
                            />
                        </FiltersPagination>
                    </div>
                </div>
            </div>
        </>

    )
}

export default ServiceRequest;